var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#F2724A",
  d: "M7.8,22.5c0,8.1,6.6,14.7,14.7,14.7s14.7-6.6,14.7-14.7S30.6,7.8,22.5,7.8S7.8,14.4,7.8,22.5z M22.5,8.6 c7.7,0,13.9,6.2,13.9,13.9c-0.1,7.7-6.2,13.8-13.9,13.9c-7.7,0-13.9-6.2-13.9-13.9S14.8,8.6,22.5,8.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M22.5,36.4c7.7-0.1,13.8-6.2,13.9-13.9c0-7.7-6.2-13.9-13.9-13.9S8.6,14.8,8.6,22.5S14.8,36.4,22.5,36.4z  M18.4,14.5c0-1.1,2-1.7,4.1-1.7c2.1,0,4.1,0.6,4.1,1.7c-0.5,3.8-1.9,12.8-4.1,12.8S18.9,18.3,18.4,14.5z M24.7,28.9v2.3v0 c0,0.6-0.4,1-1,1h-2.4c-0.6,0-1-0.4-1-1v0v-2.3c0-0.6,0.4-1,1-1h2.4C24.3,27.9,24.7,28.3,24.7,28.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F2724A",
  d: "M22.5,27.3c2.2,0,3.6-9,4.1-12.8c0-1.1-2-1.7-4.1-1.7c-2.1,0-4.1,0.6-4.1,1.7 C18.9,18.3,20.3,27.3,22.5,27.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F2724A",
  d: "M23.7,27.9h-2.4c-0.6,0-1,0.4-1,1v2.3v0c0,0.6,0.4,1,1,1h2.4c0.6,0,1-0.4,1-1v0v-2.3 C24.7,28.3,24.3,27.9,23.7,27.9z"
}));

function SvgRedExclamation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedExclamation);
export default __webpack_public_path__ + "static/media/red_exclamation.25746741b008d10944f781899b02b589.svg";
export { ForwardRef as ReactComponent };